var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinkSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "33px",
    viewBox: "0 0 58 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration/gray success ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration/gray-success-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    fill: "#ff64a5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-double-solid"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "42.560319 0 20.7597208 21.45 15.6131605 16.3862069 12.9531406 19.0034483 18.0997009 24.0672414 14.2831505 27.8224138 2.66001994 16.3862069 0 19.0034483 12.9531406 31.7482759 14.2831505 33 15.6131605 31.7482759 20.7597208 26.6844828 25.9062812 31.7482759 27.2362911 33 28.5663011 31.7482759 58 2.61724138 55.3399801 0 27.2362911 27.8224138 23.4197408 24.0672414 45.220339 2.61724138"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinkSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pink-success.31832b65e53436c16e3d78dc2b41de72.svg";